import type { FC, ReactNode } from "react";

import { Column } from "@hightouch/htui";

export const Form: FC<{
  children: ReactNode;
  compact?: boolean;
}> = ({ children, compact }) => {
  return (
    <Column flex={1} gap={compact ? 3 : 6}>
      {children}
    </Column>
  );
};
